/**
 * Which frames the pack card can page through.
 *
 * Copied from `@product/narcis/packs/pagerLooks.ts` and cut to Toile's one case (plan
 * 2026_08_30_toile_pack_page_convergence, decision 2). Narcis's version answers "which stage is this
 * and does something else already own the card's click", because a narcis pack page moves through
 * nine visual stages. A Toile pack page is a showcase and nothing else, so the answer is always
 * "every cell, in order". The stepping arithmetic (`nextLookIndex`) and the coda that follows the
 * last look live in `@core/packs/stage/pager` (plan 2026_09_23_pack_stage_coda.md).
 */

/** The reachable frame indices, in paging order. Fewer than two means the caller renders no zones. */
export function pagerLookIndices(sampleCount: number): number[] {
    return Array.from({length: Math.max(0, sampleCount)}, (_, i) => i)
}
